import axios from '@/libs/api.request'
import config from '@/config'

const workFlowBaseUrl = config.baseWorkflowUrl + '/api/v1/'

export const getDbDataMigrateFlow = (params) => {
  return axios.request({
    url: workFlowBaseUrl + 'db_data_migrate_flow/',
    params: params,
    method: 'get'
  })
}

export const detailDbDataMigrateFlow = (id) => {
  return axios.request({
    url: workFlowBaseUrl + 'db_data_migrate_flow/' + id + '/',
    method: 'get'
  })
}

export const deleteDbDataMigrateFlow = (id) => {
  return axios.request({
    url: workFlowBaseUrl + 'db_data_migrate_flow/' + id + '/',
    method: 'delete'
  })
}

export const applyDbDataMigrateFlow = (data) => {
  return axios.request({
    url: workFlowBaseUrl + 'db_data_migrate_flow/',
    data: data,
    method: 'post'
  })
}

export const refuseDbDataMigrateFlow = (id, content) => {
  return axios.request({
    url: workFlowBaseUrl + 'db_data_migrate_flow/' + id + '/refuse/',
    data: { content: content },
    method: 'post'
  })
}

export const executeDbDataMigrateFlow = (id) => {
  return axios.request({
    url: workFlowBaseUrl + 'db_data_migrate_flow/' + id + '/execute/',
    method: 'post'
  })
}

// 按项目统计每月执行数（可自定义时间节点）
export const getMigrateMon = (params) => {
  return axios.request({
    url: workFlowBaseUrl + 'migrate_mon/',
    params: params,
    method: 'get'
  })
}

// 按项目发布次数 Top10
export const getMigrateTop = (params) => {
  return axios.request({
    url: workFlowBaseUrl + 'migrate_top/',
    params: params,
    method: 'get'
  })
}

// 按执行迁移状态统计迁移数量
export const getMigrateShowStatus = (params) => {
  return axios.request({
    url: workFlowBaseUrl + 'migrate_show_status/',
    params: params,
    method: 'get'
  })
}
